import { Component, Host, Prop, h } from '@stencil/core';
import { Blog } from './sew-ws-popular-blogs.types';

@Component({
    tag: 'sew-ws-popular-blogs-item',
    styleUrl: 'sew-ws-popular-blogs-item.scss',
    shadow: true,
})
export class SewWsPopularBlogsItem {
    @Prop() blog: Blog;

    private formatDate(date: string) {
        return new Date(date).toLocaleDateString(undefined, {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
        });
    }

    render() {
        return (
            <Host>
                <a class="link" href={this.blog.url}>
                    <div class="icon">
                        <sew-icon icon="document-pen" size="xl" />
                    </div>
                    <div class="image-wrapper">
                        <sew-picture
                            img-src={this.blog.hero_picture.mq2}
                            img-alt={this.blog.hero_picture_alt}
                            img-title={this.blog.hero_picture_title}
                        >
                            <source
                                media="(max-width: 600px)"
                                srcSet={`${this.blog.hero_picture.mq1} 1x, ${this.blog.hero_picture.mq1r} 2x`}
                            />
                            <source
                                media="(max-width: 1344px)"
                                srcSet={`${this.blog.hero_picture.mq2} 1x, ${this.blog.hero_picture.mq2r} 2x`}
                            />
                            <source
                                media="(max-width: 2456px)"
                                srcSet={`${this.blog.hero_picture.mq3} 1x, ${this.blog.hero_picture.mq3r} 2x`}
                            />
                        </sew-picture>
                    </div>
                    <div class="content">
                        <div class="date">{this.formatDate(this.blog.date)}</div>
                        <div class="headline">
                            <sew-icon class="svg" icon="arrow-right" size="s" />
                            {this.blog.headline}
                        </div>
                        <div class="tags">
                            {this.blog.tags.map(tag => (
                                <div class="tag" slot="target">
                                    {tag}
                                </div>
                            ))}
                        </div>
                    </div>
                </a>
            </Host>
        );
    }
}
